import { useAuth } from '@/providers/auth.provider'
import { BellOutlined, MenuOutlined } from '@ant-design/icons'
import { Badge, Button, Image, Row, Space } from 'antd'
import { memo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useInfiniteQuery } from 'react-query'
import PBFNotificationDialog from './PBFNotificationDialog/PBFNotificationDialog'
import LOGO from '@/assets/images/icon.png'
import HttpRequest from '@/config/axios.config'
import Fade from '@/components/Fade'
import { useMobileSidebar } from './MobileSidebarContext'
import MobileProfileDrawer from './MobileProfileDrawer'

interface Prop {
  title: string
  icon: any
  background: string
}
function Header(props: Prop) {
  const { title, icon, background } = props
  const navigate = useNavigate()
  const { user } = useAuth()
  const [openNotification, setOpenNotification] = useState(false)
  const [openProfileDrawer, setOpenProfileDrawer] = useState(false)
  const { isMobile, openMobileSidebar } = useMobileSidebar()

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery(
    ['notification-header'],
    ({ pageParam = 1 }) => {
      return HttpRequest.get(`notifications`, {
        params: { page_number: pageParam, page_size: 10 },
      })
    },
    {
      getNextPageParam: (lastPage: any) => {
        const nextPage = lastPage.data?.pagination?.next_page
        const totalPage = lastPage.data?.pagination?.total_page
        return nextPage <= totalPage ? nextPage : false
      },
      keepPreviousData: true,
    }
  )

  return (
    <div
      className="header-container"
      style={{
        background,
      }}
    >
      <div className="icon-header">{icon}</div>
      <Row justify="space-between" align="middle">
        <Space align="center" size="middle">
          {isMobile && (
            <Button
              type="text"
              size="large"
              className="mobile-menu-trigger"
              icon={<MenuOutlined />}
              onClick={openMobileSidebar}
            />
          )}
          <Fade>
            <p className="header-title">{title}</p>
          </Fade>
        </Space>
        <Space align="center" size={'middle'} wrap>
          <Badge
            className="hide-on-mobile"
            count={data?.pages[0].data?.data?.totalUnview ?? 0}
          >
            <Button
              type="text"
              size="large"
              icon={<BellOutlined />}
              onClick={async () => {
                setOpenNotification(true)
                await HttpRequest.put('notifications/views')
                refetch()
              }}
            />
          </Badge>
          <Button
            size="large"
            type="text"
            className="profile-button"
            onClick={() => {
              if (isMobile) {
                setOpenProfileDrawer(true)
                return
              }

              navigate('/user-profile')
            }}
          >
            <Image
              loading="lazy"
              src={user?.avatar?.url_path ?? ''}
              fallback={LOGO}
              preview={false}
              alt="Profile"
            />
          </Button>
        </Space>
      </Row>
      {openNotification && (
        <PBFNotificationDialog
          open={openNotification}
          data={data}
          fetchNextPage={() => {
            console.log('true', true)
            fetchNextPage()
          }}
          hasNextPage={hasNextPage}
          isFetching={isFetching && !isFetchingNextPage}
          onCancel={() => {
            setOpenNotification(false)
          }}
        />
      )}
      <MobileProfileDrawer
        open={isMobile && openProfileDrawer}
        onClose={() => setOpenProfileDrawer(false)}
      />
    </div>
  )
}

export default memo(Header)
